import React, {useEffect, useState} from 'react';
import DataBlock from "../../components/DataBlock";
import {dictionaries} from "./dictionaries";
import Section from "../../components/Section";
import {Button, Form} from "semantic-ui-react";
import './styles.scss';
import Field from "../../components/Field";
import {apiPost, apiPut} from "../../services/apiClient";
import {toast} from "react-toastify";
import {checkMatch, isEmpty, objToQueryString, removeNullProperties} from "../../services/utils";
import {findPhoneNumbersInText} from "libphonenumber-js";
import {getCard} from "../../grids/api";
import {getRoles} from "../../services/userRights";

const DictionaryCard = ({match, history}) => {
    const name = match.params.name;
    const id = match.params.id;
    const [dictionaryData, setDictionaryData] = useState({});
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const d = dictionaries.find(d => d.key === name);
        d ? setDictionaryData(d) : history.push('/');
    }, [name])

    const toList = (filters) => {
        history.push(`/dictionary/${name}${filters ? '?'+objToQueryString(filters) : ''}`);
    }

    const label = dictionaryData.label;
    const columns = dictionaryData.columns || [];

    const canViewCol = col => {
        return (id || !col.hiddenForNew) && (!col.rolesForView || checkMatch(getRoles(), col.rolesForView));
    }

    const blocks = [...new Set(columns.filter(c => canViewCol(c)).map(c => c.block || 0))];

    const fieldBlocks = blocks.map(b => ({
        block: b,
        fields: columns.filter(col => (b !== 0 ? col.block === b : !col.block) && canViewCol(col))
    }))

    const onChange = (name, value, error) => {
        setErrors(e => ({
            ...e,
            [name]: error || null
        }))
        setForm(f => ({
            ...f,
            [name]: value
        }))
    }

    const errorSave = (d) => {
        if (d.hasErrors) {
            toast.error(Object.keys(d.messages).map(k => d.messages[k]).join(';\n'));
            setErrors(d.messages)

            if (name === 'myaddresses' && d.existEntryId) {
                getCard(name, d.existEntryId)
                    .then(d => {
                        toList({
                            address: d.address,
                            companyName: d.companyName,
                            contactName: d.contactName
                        });
                    })
            }
        }
    }

    const isValid = () => {
        const requiredFields = columns.filter(c => canViewCol(c) && c.isRequired);
        let errs = {...errors};
        errs = removeNullProperties(errs);
        requiredFields.forEach(rF => {
            if (isEmpty(form[rF.fieldName])) errs[rF.fieldName] = `Поле ${rF.title} обязательно к заполнению`;
        });
        columns.forEach(col => {
            if(col.fieldType === 'phone' && !errs[col.fieldName] && findPhoneNumbersInText(form[col.fieldName]).length === 0) errs[col.fieldName] = `Неверные данные в поле ${col.title}`;
        })
        if (Object.keys(errs).length > 0) {
            errorSave({
                hasErrors: true,
                messages: errs
            });
            return false;
        }
        else return true;
    }
    const save = () => {
        if (isValid()) {
            !id
                ? apiPut(`${name}/new`, form)
                    .then(d => {
                        toList()
                    })
                    .catch(errorSave)
                : apiPost(`${name}/${id}`, form)
                    .then(d => {
                        toList()
                    })
                    .catch(errorSave)
        }
    }
    const getCardData = () => {
        getCard(name, id)
            .then(d => {
                setForm(d)
            })
            .catch(e => {
                toast.error('Объекта с данным id не существует');
                toList();
            })
    }

    useEffect(() => {
        id && getCardData();
    }, [id])

    useEffect(() => {
        (!id && columns.length) && setDefaultValues();
    }, [columns])

    const canEdit = id ? form.isEditable : true;

    const disabledCol = (col) => {
        return (id && col.disabledForEdit)
            || (!id && col.disabledForNew)
            || (col.rolesForEdit && !checkMatch(getRoles(), col.rolesForEdit))
            || !canEdit
    }

    const setDefaultValues = () => {
        const fieldsWithDefaultValue = columns.filter(col => col.defaultValue);
        if (fieldsWithDefaultValue.length) {
            let defaultValues = {};
            fieldsWithDefaultValue.map(col => {
                defaultValues[col.fieldName] = typeof col.defaultValue === 'function' ? col.defaultValue() : col.defaultValue;
            })
            setForm(defaultValues);
        }
    }

    return (
        <div className='dictionary-card'>
            <DataBlock
                label={label}
                maxSize
            >
                <Section padding0>
                    <Form>
                        {
                            fieldBlocks.map(fB => (
                                <div className='dictionary-card__form' key={'key_' + fB.block}>
                                    {
                                        fB.fields.map(col => (
                                            <Field
                                                disabled={disabledCol(col)}
                                                width={col.fieldWidth}
                                                label={col.title}
                                                key={col.fieldName}
                                                name={col.fieldName}
                                                error={errors[col.fieldName]}
                                                isRequired={col.isRequired}
                                                value={form[col.fieldName]}
                                                type={col.fieldType}
                                                info={col.info}
                                                maxLength={col.maxLength}
                                                onChange={onChange}
                                                sourceOptionsUrl={col.optionsUrl || `${name}/${col.fieldName}`}
                                            />
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </Form>
                </Section>
                <div className='step-btn-block'>
                    <Button onClick={() => toList()}>Отмена</Button>
                    <Button disabled={!canEdit} className='modal__actions_yes' onClick={save}>Сохранить</Button>
                </div>
            </DataBlock>
        </div>
    );
};

export default DictionaryCard;


// WEBPACK FOOTER //
// ./App/pages/dictionaries/dictionaryCard.jsx